export default "__VITE_ASSET__DCEH_NiK__"